import {
	createSlice,
	createEntityAdapter,
	createAsyncThunk,
} from "@reduxjs/toolkit";
import { getTreeByDomain } from "api";
const treesAdapter = createEntityAdapter();

const initialState = treesAdapter.getInitialState({
	status: "idle",
	error: null,
});

export const fetchTreeByDomain = createAsyncThunk(
	"tree/fetchTreeByDomain",
	async ({ domain, parentId }, { rejectWithValue, dispatch }) => {
		try {
			//the id of the tree will be equal to the domain
			//the hierarchy api doesn't return an id column
			//api returns array but only ever 1 object in array
			let tree = await getTreeByDomain({ domain, parentId });
			tree = { id: domain, name: domain, domain, parentId, tree };
			dispatch(treeUpserted(tree));
		} catch (error) {
			console.error(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const treesSlice = createSlice({
	name: "trees",
	initialState,
	reducers: {
		treesReceived(state, action) {
			treesAdapter.setAll(state, action.payload);
		},
		treeUpserted(state, action) {
			treesAdapter.upsertOne(state, action.payload);
		},
	},
	extraReducers: {
		[fetchTreeByDomain.fulfilled]: (state, action) => {
			state.status = "succeeded";
		},
		[fetchTreeByDomain.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
		},
	},
});

/*
ACTIONS
trees data can only ever be received via API
There are no actions to CRUD individual trees
*/
export const { treesReceived, treeUpserted } = treesSlice.actions;

/*
SELECTORS
*/
export const { selectAll: selectAllTrees, selectById: selectTreeById } =
	treesAdapter.getSelectors((state) => state.trees);

/*
CUSTOM SELECTORS
*/
export const selectTreesError = (state) => state.trees.error;

export default treesSlice.reducer;
